import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1d51bf16&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1d51bf16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d51bf16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d51bf16')) {
      api.createRecord('1d51bf16', component.options)
    } else {
      api.reload('1d51bf16', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1d51bf16&scoped=true&", function () {
      api.rerender('1d51bf16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/addBank/index.vue"
export default component.exports